import fetch from '@/utils/fetch';

export function ancList(query) {
    return fetch({
        url: '/Cqjcom/Cqjcom/getNoticeByKeyword',
        method: 'post',
        data: query
    });
}

export function ancRemove(query) {
    return fetch({
        url: '/Cqjcom/Cqjcom/batchDeleteNotice',
        method: 'post',
        data: query
    });
}

export function ancEdit(query) {
    return fetch({
        url: '/Cqjcom/Cqjcom/saveNotice',
        method: 'post',
        data: query
    });
}

export function ancPredat(query) {
    return fetch({
        url: '/Cqjcom/Cqjcom/getManageNoticeById',
        method: 'post',
        data: query
    });
}

export function ancStatusSet(query) {
    return fetch({
        url: '/Cqjcom/Cqjcom/updateStatusNotice',
        method: 'post',
        data: query
    });
}



// WEBPACK FOOTER //
// ./src/api/announcement/announcement.js